var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foreground-container"},[_c('div',{staticClass:"container"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$t('exchange_application_completed'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }